import React from "react";
import { useLocation } from "react-router-dom";
import SuperAdminReferAndEarnContent from "./SuperAdminReferAndEarnContent";

const SuperAdminReferAndEarn = () => {
  const location = useLocation();
  const token = localStorage.getItem("superadmintoken");
  const userId = location.state?.userId || "";

  return (
    <SuperAdminReferAndEarnContent
      token={token}
      userId={userId}
      workerType="superadmin"
    />
  );
};

export default SuperAdminReferAndEarn;